import { DataBars, DataBarsRow } from "@/components/data-bars/DataBars.tsx";
import { Box, Button, Stack } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ExpandableDataBarsProps {
  rows: DataBarsRow[];
  showMoreAfter?: number;
}

export const ExpandableDataBars = ({ rows, showMoreAfter = 6 }: ExpandableDataBarsProps) => {
  const { t } = useTranslation();
  const [isShowAll, setIsShowAll] = useState(false);
  const itemsToShow = isShowAll ? rows.length : Math.min(showMoreAfter, rows.length);
  const remainingCount = rows.length - itemsToShow;

  return (
    <Stack className={"pt-6"} gap={"lg"}>
      <DataBars rows={rows.slice(0, itemsToShow)} className={"p-0"} />
      {remainingCount > 0 && (
        <Box>
          <Button variant={"secondary"} onClick={() => setIsShowAll(true)}>
            {t("common:show_more_template", { count: remainingCount })}
          </Button>
        </Box>
      )}
    </Stack>
  );
};
